export const SearchActionTypes = {
	CHANGE_SEARCH_FIELD : 'CHANGE_SEARCH_FIELD'
};